import * as React from "react";
import "./App.css";
import NavBarLayout from "./NavbarLayout";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { buttonStyle } from "./colors";
import Outfit1 from "./outfits/outfit 1.png";
import Outfit21 from "./outfits/outfit 21.png";
import { IoMdCheckmark } from "react-icons/io";
import { IoMdHeart } from "react-icons/io";
import { FaComment } from "react-icons/fa6";
import { IoIosArrowDown } from "react-icons/io";
import { CgProfile } from "react-icons/cg";
import { IconButton } from "@mui/material";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { iconColor, primaryColor } from "./colors";
import CommentSection from "./CommentSection";
import { getRandomComments, getRandomNumber } from "./Data";

const OUTFITS = [Outfit1, Outfit21];
const OUTFIT_NAMES = ["Chic Office Fit", "Classy Office Fit"];
const OUTFIT_DESC = [
  "A chic office outfit, with a cream colored short sleeve top and gray slacks",
  "A classy office fit, with a beige suit jacket layered over a white button down and a brown skirt",
];

function ManualOutfit() {
  const navigate = useNavigate();
  const [outfitIndex, setOutfitIndex] = React.useState(0);
  const [commentsOpen, setCommentsOpen] = React.useState(false);

  const dataKey = "manual_outfit" + OUTFIT_NAMES[outfitIndex];
  const numComments = getRandomNumber("comments" + dataKey, 5, 30);
  const numLikes = getRandomNumber("likes" + dataKey, 20, 100);

  return (
    <NavBarLayout
      title="Choose #OOTD"
      onBackButtonClicked={() => navigate("/outfitmethods")}
      active={0}
    >
      <div className="ManualOutfit-container">
        <div className="eventLabel">Event: Work Day</div>
        <div className="ManualOutfit-imageContainer">
          <div className="ManualOutfit-card ManualOutfit-center">
            <span className="outfitLabel">{OUTFIT_NAMES[outfitIndex]}</span>
            <img
              style={{ width: "70%" }}
              className="ManualOutfit-image"
              src={OUTFITS[outfitIndex]}
              alt={OUTFIT_DESC[outfitIndex]}
            ></img>
          </div>
          <div className="ManualOutfit-leftArrow">
            <IconButton
              onClick={() =>
                setOutfitIndex(
                  (outfitIndex + OUTFITS.length - 1) % OUTFITS.length
                )
              }
            >
              <IoIosArrowBack color={iconColor} size="3rem" />
            </IconButton>
          </div>
          <div className="ManualOutfit-rightArrow">
            <IconButton
              onClick={() => setOutfitIndex((outfitIndex + 1) % OUTFITS.length)}
            >
              <IoIosArrowForward color={iconColor} size="3rem" />
            </IconButton>
          </div>

          <div className="ManualOutfit-outfitButtons">
            <IoMdHeart size="2rem" color="#636291" />
            <div>{numLikes}</div>
            <FaComment
              onClick={() => setCommentsOpen(true)}
              size="1.75rem"
              color="#636291"
            />
            <div>{numComments}</div>
          </div>
        </div>
        <div className="ManualOutfit-buttonContainer">
          <Button
            onClick={() => {
              sessionStorage.setItem("outfitIndex", outfitIndex);
              sessionStorage.setItem("method", "manual");
              navigate("/home");
            }}
            sx={{ ...buttonStyle }}
            variant="contained"
          >
            <span className="Autogenerate-buttonText">Confirm</span>
            <IoMdCheckmark />
          </Button>
        </div>
      </div>
      <CommentSection
        dataKey={dataKey}
        numComments={numComments}
        open={commentsOpen}
        setOpen={setCommentsOpen}
      />
    </NavBarLayout>
  );
}

export default ManualOutfit;
